import { ChartOptions, ChartData } from 'chart.js';
import React, { useState, memo, useMemo, useRef, useCallback } from 'react';
import { Doughnut } from 'react-chartjs-2';
import trans from 'translation';
import { KContainer, KLabel } from 'uikit';

const Summary = () => {
  const [dragging] = useState(false);

  // const [startX, setStartX] = useState(0);

  const [translateX] = useState(0);

  const [pageShow] = useState(1);

  const containerRef = useRef<HTMLDivElement>(null);

  // const [autoPaginationEnabled, setAutoPaginationEnabled] = useState(true);

  // useEffect(() => {
  //   const ref = containerRef.current;
  //   if (!ref) return;

  //   const handleMouseEnter = () => setAutoPaginationEnabled(false);
  //   const handleMouseLeave = () => setAutoPaginationEnabled(true);

  //   ref.addEventListener('mouseenter', handleMouseEnter);
  //   ref.addEventListener('mouseleave', handleMouseLeave);

  //   return () => {
  //     ref.removeEventListener('mouseenter', handleMouseEnter);
  //     ref.removeEventListener('mouseleave', handleMouseLeave);
  //   };
  // }, []);

  // useEffect(() => {
  //   if (!autoPaginationEnabled) return;

  //   const timeout = setTimeout(() => {
  //     const direction = 1;
  //     setTranslateX(direction * -200);

  //     setTimeout(() => {
  //       setPageShow(prev => (prev >= 5 ? 1 : prev + 1));
  //       setTranslateX(0);
  //     }, 300);
  //   }, 3000);

  //   return () => clearTimeout(timeout);
  // }, [autoPaginationEnabled, pageShow]);

  // useEffect(() => {
  //   if (autoPaginationEnabled) {
  //     const timeout = setTimeout(() => {
  //       setPageShow((prev: any) => (prev >= 5 ? 1 : prev + 1));
  //     }, 3000);

  //     return () => clearTimeout(timeout);
  //   }
  // }, [autoPaginationEnabled, pageShow]);

  const equipments1 = useMemo(() => {
    return {
      license_valid: 40,
      registration_expired: 10,
      no_registration: 40
    };
  }, []);

  const equipments2 = useMemo(() => {
    return {
      in_good_condition: 40,
      faulty: 10,
      in_repair: 40
    };
  }, []);

  const mappedLabel: Record<string, string> = useMemo(() => {
    return {
      license_valid: trans('license_valid'),
      registration_expired: trans('registration_expired'),
      no_registration: trans('no_registration'),
      in_good_condition: trans('in_good_condition'),
      faulty: trans('faulty'),
      in_repair: trans('in_repair')
    };
  }, []);

  const formatChartData = useCallback(
    (
      inputData: Record<string, number>,
      colors: string[]
    ): ChartData<'doughnut'> => {
      const labels = Object.keys(inputData).map(key => mappedLabel[key] || key);
      const values = Object.values(inputData);

      return {
        labels,
        datasets: [
          {
            data: values,
            backgroundColor: colors.slice(0, values.length),
            borderWidth: 0
          }
        ]
      };
    },
    [mappedLabel]
  );

  const chartColors = useMemo(() => {
    return ['#13A89E', '#D94B4B', '#FFA000'];
  }, []);

  const chartData1 = useMemo(() => {
    switch (pageShow) {
      case 1:
        return formatChartData(equipments1, chartColors);
    }
    return formatChartData(equipments1, chartColors);
  }, [pageShow, chartColors, equipments1, formatChartData]);
  const chartData2 = useMemo(() => {
    switch (pageShow) {
      case 1:
        return formatChartData(equipments2, chartColors);
    }
    return formatChartData(equipments2, chartColors);
  }, [pageShow, chartColors, equipments2, formatChartData]);

  const CenterTextPlugin = {
    id: 'centerText',
    beforeDraw: (chart: any) => {
      const { width } = chart;
      const { height } = chart;
      const ctx = chart.ctx;
      ctx.restore();
      const fontSize = (height / 60).toFixed(2);
      ctx.font = `bold ${fontSize}em sans-serif`;
      ctx.textBaseline = 'middle';

      const total = chart.data.datasets[0].data.reduce(
        (sum: number, value: number) => sum + Number(value),
        0
      );
      const text = total;
      const textX = Math.round((width - ctx.measureText(text).width) / 2);
      const textY = height / 2;

      ctx.fillStyle = '#000';
      ctx.fillText(text, textX, textY);
      ctx.save();
    }
  };

  const options: ChartOptions<'doughnut'> = {
    cutout: '70%',
    plugins: {
      legend: {
        display: false,
        position: 'right',
        labels: {
          color: '#0e5421'
        }
      },
      tooltip: {
        enabled: true
      }
    }
  };

  const titles = [trans('equipments')];

  const renderChartCard = () => (
    <KContainer.View marginR="0.25rem" marginT="1rem" height={200} flexG={1}>
      <KContainer.View
        dp="inline-flex"
        direction="row"
        alignItems="center"
        flexG={1}
      >
        <KContainer.View height={100} width={100} marginL="0rem" marginR="1rem">
          <Doughnut
            data={chartData1}
            options={options}
            plugins={[CenterTextPlugin]}
          />
        </KContainer.View>

        <KContainer.View
          dp="flex"
          direction="column"
          alignSelf="flex-start"
          flexG={1}
          marginR="1rem"
        >
          {(chartData1?.labels as string[])?.map((label, idx) => (
            <KContainer.View
              key={idx}
              dp="inline-flex"
              direction="row"
              alignItems="center"
              marginB="0.5rem"
            >
              <KContainer.View
                background={chartColors[idx]}
                height={8}
                width={8}
                margin="0.5rem"
              />
              <KLabel.Text margin="0.5rem" width="7rem">
                {mappedLabel[label] || label}
              </KLabel.Text>
              <KLabel.Text margin="0.5rem">
                {chartData1.datasets[0].data[idx]}
              </KLabel.Text>
            </KContainer.View>
          ))}
        </KContainer.View>

        <KContainer.View height={100} width={100} marginL="1rem" marginR="1rem">
          <Doughnut
            data={chartData2}
            options={options}
            plugins={[CenterTextPlugin]}
          />
        </KContainer.View>

        <KContainer.View
          dp="flex"
          direction="column"
          alignSelf="flex-start"
          flexG={1}
          marginR="1rem"
        >
          {(chartData2?.labels as string[])?.map((label, idx) => (
            <KContainer.View
              key={idx}
              dp="inline-flex"
              direction="row"
              alignItems="center"
              marginB="0.5rem"
            >
              <KContainer.View
                background={chartColors[idx]}
                height={8}
                width={8}
                margin="0.5rem"
              />
              <KLabel.Text margin="0.5rem" width="7rem">
                {mappedLabel[label] || label}
              </KLabel.Text>
              <KLabel.Text margin="0.5rem">
                {chartData2.datasets[0].data[idx]}
              </KLabel.Text>
            </KContainer.View>
          ))}
        </KContainer.View>
      </KContainer.View>
    </KContainer.View>
  );

  return (
    <KContainer.Card
      height={250}
      marginT={0}
      dp="flex"
      direction="row"
      flexG={1}
      alignItems="stretch"
      ref={containerRef}
    >
      <KContainer.Card
        height="95%"
        flexG={1}
        dp="flex"
        alignItems="stretch"
        header={{
          title: titles[pageShow - 1],
          typo: 'TextMdBold'
        }}
        style={{
          // display: 'flex',
          transform: `translateX(${translateX}px)`,
          transition: dragging ? 'none' : 'transform 0.2s ease'
          // transition: 'transform 0.3s ease'
        }}
      >
        <KLabel.Text
          color="#FF0000"
          dp="flex"
          flexG={1}
          alignSelf="flex-end"
          style={{ marginTop: '-2rem' }}
          typo="TextMdMedium"
        >
          {`Today ${new Date().toLocaleDateString()}`}
        </KLabel.Text>
        {renderChartCard()}
      </KContainer.Card>
    </KContainer.Card>
  );
};

export default memo(Summary);
